import styled from "styled-components";

export const AlertWithCenteredMessage = styled.div`
    .MuiAlert-action {
        align-self: center;
    }
`;

export const WidgetArea = styled.div<{ isTablet: boolean }>`
    display: grid; 
    grid-template-columns: repeat(12, minmax(1px, 8.33%));
    gap: 30px;
    padding: 40px 0;
    width: 100%;
    grid-auto-rows: minmax(440px, auto);
    column-gap: ${({ isTablet }) => isTablet && '0'};
`;
